<template>
    <div class="container">
        <div class="header">
            <div class="banner">
                <div class="title_banner">
                    <img :src="titleBannerImage">
                </div>
            </div>
        </div>
        <div class="context">
            <!-- 大会介绍 -->
            <div class="introduce mt--83">
                <!-- 功能标题 -->
                <div class="feature_title mb-66">大会介绍</div>

                <div class="left_title mb-29">影响力·时代峰会</div>

                <div class="text mb-60">
                    {{ yingxiangliText }}
                </div>

                <div class="left_title mb-29">时代金融金桔奖</div>

                <div class="text mb-33">
                    {{ jiangText1 }}
                </div>

                <div class="text mb-71">
                    {{ jiangText2 }}
                </div>

                <div class="feature_title mb-30">主题介绍</div>

                <div class="introduce-image mb-15">
                    <img :src="introduceImage">
                </div>
                <div class="left_title mb-29">金融聚力</div>
                <div class="text mb-60">
                    {{ juliText }}
                </div>

                <div class="left_title mb-29">智造向新</div>
                <div class="text mb-20">
                    {{ zhizaoText1 }}
                </div>
                <div class="text mb-60">
                    {{ zhizaoText2 }}
                </div>
            </div>

            <div class="introduce">
                <!-- 功能标题 -->
                <div class="feature_title">时代金融金桔奖奖项设置</div>
                <div class="setting-image mb-66">
                    <img :src="settingImage">
                </div>
                <div class="feature_title mb-34">评选标准</div>
                <div class="select_image mb-52">
                    <img :src="selectImage">
                </div>

                <div class="left-image mb-13">
                    <img :src="leftImage">
                </div>
                <div class="text mb-34">
                    {{ selectText1 }}
                </div>
                <div class="text">
                    {{ selectText2 }}
                </div>
            </div>

            <div class="introduce">
                <!-- 功能标题 -->
                <div class="feature_title mb-30">活动议程</div>

                <div class="mb-47">
                    <div class="left_title mb-15">
                        <span class="bottom_line mr-36">金融聚力</span>
                        <span>智造向新</span>
                    </div>

                    <div class="long_line"></div>
                </div>

                <div class="flow_tip mb-27">
                    <div class="text text_before">11.22</div>
                    <div class="text text_after">流程</div>
                </div>

                <Card class="mb-95"></Card>

                <div class="feature_title mb-41">大咖一览</div>

                <Carousel class="mb-96"></Carousel>

                <div class="feature_title mb-41">最新资讯</div>

                <div class="mb-47">
                    <div class="left_title mb-15">
                        <!-- <span class="bottom_line mr-36">本届报道</span> -->
                        <span class="bottom_line mr-36"> 往届报道</span>
                    </div>

                    <div class="long_line"></div>
                </div>

                <MsgCarousel class="mb-41"></MsgCarousel>

                <div class="left_small_title mb-29">
                    相关新闻
                </div>

                <News></News>
            </div>


            <!-- <div class="introduce">
                <div class="big_title mt-30">参选企业</div>
                <FirmList></FirmList>

                <div class="buttonWrapper cursor-pointer">
                    <div class="button" @click="jumpDetail">查看详情</div>
                </div>

            </div> -->

            <div class="introduce">
                <div class="mb-47 mt-41">
                    <div class="left_title mb-15">
                        <span class="bottom_line mr-36">精彩瞬间</span>
                    </div>

                    <div class="long_line"></div>
                </div>
                <InstantCarousel class="mb-95"></InstantCarousel>

                <div class="mb-45">
                    <div class="left_title mb-15">
                        <span class="bottom_line mr-36">相关视频</span>
                    </div>

                    <div class="long_line"></div>
                </div>

                <Video class="mb-96"></Video>

                <!-- <div class="feature_title mb-70">合作伙伴</div> -->
                <div class="mb-57">
                    <div class="left_title">
                        <div class="bottom_left_line mr-36">
                        </div>
                    </div>
                    <div class="long_line"></div>
                </div>
                <div class="mb-42">
                    <img :src="zhubanPartnerImage" style="width: 156px">
                </div>
                <div class="mb-42">
                    <img :src="chengbanPartnerImage" style="width: 494px">
                </div>
                <div class="mb-111">
                    <img :src="hezuoImage">
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import News from "./components/News"
import Card from "./components/Card";
import Video from "./components/Video";
import Carousel from "./components/Carousel";
import FirmList from "./components/FirmList";
import MsgCarousel from "./components/MsgCarousel";
import InstantCarousel from "./components/InstantCarousel";
import titleBannerImage from "@/assets/img/jinju-2024/title_banner@2x.png";
import introduceImage from "@/assets/img/jinju-2024/img_title_zhuti@2x.png"
import settingImage from "@/assets/img/jinju-2024/img_prize_gongsi@2x.png"
import selectImage from "@/assets/img/jinju-2024/title_pingxuan@2x.png";
import leftImage from "@/assets/img/jinju-2024/decorate_yinhao_pingxuan@2x.png"
import zhubanPartnerImage from "@/assets/img/jinju-2024/img_zhuban@2x.png"
import chengbanPartnerImage from "@/assets/img/jinju-2024/img_chengban@2x.png"
import partnerImage from "@/assets/img/jinju-2024/img_hezuohuoban@2x.jpg"
import hezuoImage from "@/assets/img/jinju-2024/hezuo.png"




export default {
    components: {
        News,
        Card,
        Video,
        Carousel,
        FirmList,
        MsgCarousel,
        InstantCarousel
    },

    data() {
        return {
            leftImage,
            hezuoImage,
            selectImage,
            settingImage,
            partnerImage,
            chengbanPartnerImage,
            introduceImage,
            titleBannerImage,
            zhubanPartnerImage,
            yingxiangliText: "“影响力· 时代”峰会是广东时代传媒集团精心打造的系列高端论坛，已成功举办十一届。峰会旨在汇聚学术界、思想界、产业界最具影响力的先驱者与决策者，解读最新经济政策和经济热点，共同探索中国经济新趋势，为持续提升中国经济实力与中国企业影响力建言献策。",
            jiangText1: "“时代金融金桔奖”着眼“风控、服务、改革”，评选金融业及上市公司各领域的领军者，记录中国金融业的发展变迁，汇聚更多智慧与力量以面对市场环境变化，共同助力金融践行为实体经济服务的天职。",
            jiangText2: "这里是与未来大千世界互联的平台——各领域专家学者及企业创领者相聚于此，使共创成为可能。在创意碰撞中汲取力量，成为行业人的灵感源泉，评选当年优秀的金融案例并给予充分的肯定，为金融发展献一份力量。",
            juliText: "金融是国民经济的血脉，为实体经济服务是金融的天职。科技驱动、市场变化、监管调整，变化无时不在，金融发展亦持续出现新特征，呈现新业态，产生新模式。无论变迁如何演进，锚定实体经济、紧扣实体经济、服务实体经济，才是金融赋能经济发展的核心要义。做好“五篇大文章”，汇聚服务资源，金融才可蓄力经济发展新动能，成为高质量发展的有效助力。",
            zhizaoText1: "中国制造业具有全、多、大等优势，同时已行至爬坡过坎、由大变强的关键时期。新一轮科技产业变革与中国加快转变经济发展方式形成历史性交汇，“制造”变“智造”正处交汇点中心。智能制造加速释放经济发展新势能，推动打造新经济增长极，已成为各界共识。上市公司是各行各业的领头羊，理应成为推动智能制造再上层楼的主要力量。",
            zhizaoText2: "金融聚力，智造向新。双轮驱动，协同前行。广东时代传媒集团是中国经济创新发展的观察者、记录者，我们希望举办此次峰会，汇聚各方思想，共同前瞻中国经济发展的新趋势。同时，我们将举办第九届时代金融金桔奖，以此表彰那些守正创新、锐意改革的卓越企业群体。",
            selectText1: "为助力、推动中国经济的高质量发展，为资本市场和国民经济持续健康发展提供有力支持，时代金融金桔奖由广东时代传媒集团发起、多家上市公司和金融机构参与。",
            selectText2: "评选过程中，秉着“求真、求全、求细”的原则，本次评选从预热报名、资格审查、入围评审到终审，评审会对各个环节严格把关，引入大数据技术反复比对，坚持从盈利能力、技术研发、行业引领、公众评价、社会责任等多维度出发，努力在金融科技日新月异的新时代，打造出我国金融业和财经媒体圈最具价值、最具影响力、最具权威性的跨界评选。",
        }
    },
    methods: {
        jumpDetail() {
            this.$router.push("/timesJinju-2024-detail");
        }
    }
}


</script>

<style lang="scss" scoped>
.container {
    width: 100%;
    height: fit-content;
    background-color: #13349C;

    .header {
        .banner {
            height: 910px;
            width: 100%;
            background-image: url(~@/assets/img/jinju-2024/banner@2x.png);
            background-position: center;
            background-size: cover;
            background-repeat: no-repeat;

            .title_banner {
                height: fit-content;
                width: fit-content;
                padding-top: 83px;
                margin-left: auto;
                margin-right: auto;

                img {
                    width: 832px;
                    height: 368px;
                    margin: 0 auto 0;
                }
            }

        }
    }

    .context {
        width: 100%;
        height: 100%;
        padding-bottom: 177px;

        .bottom_line {
            position: relative;

            &::after {
                content: "";
                width: 100%;
                height: 2px;
                position: absolute;
                left: 50%;
                transform: translateX(-50%);
                bottom: -16px;
                background: #3DD0F5;
            }
        }

        .bottom_left_line {
            width: 80px;
            height: 2px;
            background: #3DD0F5;
        }

        .introduce {
            width: 1200px;
            background: #2658C8;
            opacity: 0.94;
            margin: 0 auto 50px;
            padding: 55px 100px;

            .introduce-image {
                width: 376px;
                height: 62px;
                margin-left: auto;
                margin-right: auto;
            }

            .setting-image {
                width: 925px;
                height: 551px;
                margin-left: auto;
                margin-right: auto;
            }

            .select_image {
                height: 24px;
                width: 677px;
                margin-left: auto;
                margin-right: auto;
            }

            .feature_title {
                font-family: FZDeSaiHeiS;
                font-weight: 550;
                font-size: 25px;
                color: #3DD0F5;
                line-height: 22px;
                text-align: center;
            }

            .left_title {
                color: #3dd0f5;
                font-size: 20px;
                line-height: 28px;
                font-family: Source Han Sans CN;
                font-weight: bold;
            }

            .text {
                font-family: Source Han Sans CN;
                font-weight: 400;
                font-size: 16px;
                color: #FFFFFF;
                line-height: 28px;
            }

            .left-image {
                width: 45px;
                height: 41px;
            }

            .long_line {
                width: 100%;
                height: 1px;
                background: #3DD0F5;
            }

            .left_small_title {
                font-family: Hiragino Sans GB;
                font-weight: normal;
                font-size: 16px;
                color: #FFFFFF;
                line-height: 24px;
                position: relative;
                margin-left: 15px;

                &::before {
                    content: "";
                    position: absolute;
                    left: -16px;
                    top: 50%;
                    transform: translateY(-50%);
                    width: 4px;
                    height: 14px;
                    background: #3DD0F5;
                    margin-top: 1px;
                }
            }

            .flow_tip {
                display: flex;

                .text_before {
                    font-weight: 100;
                    font-size: 18px;
                    color: #3DD0F5;
                    line-height: 22px;
                    margin-right: 20px;
                    font-family: Public Sans;

                    position: relative;

                    &::after {
                        content: "";
                        top: 50%;
                        right: -10px;
                        width: 1px;
                        height: 100%;
                        background: #3DD0F5;
                        position: absolute;
                        transform: translateY(-50%);

                    }
                }

                .text_after {
                    font-family: Source Han Sans CN;
                    font-weight: 400;
                    font-size: 18px;
                    color: #3DD0F5;
                    line-height: 22px;
                }
            }

            .big_title {
                font-family: FZDeSaiHeiS;
                font-weight: normal;
                font-size: 30px;
                color: #3DD0F5;
                line-height: 22px;
                text-align: center;
            }

        }
    }

    .buttonWrapper {
        display: flex;
        justify-content: center;
        align-items: center;
        margin-bottom: 13px;

        .button {
            font-family: Source Han Sans CN;
            font-weight: 400;
            font-size: 16px;
            color: #FFFFFF;
            padding: 13px 49px;
            background: #13349C;

        }
    }



    .mb-0 {
        margin-bottom: 0 !important;
    }

    .mb-10 {
        margin-bottom: 10px;
    }

    .mb-13 {
        margin-bottom: 13px;
    }

    .mb-15 {
        margin-bottom: 15px;
    }

    .mb-20 {
        margin-bottom: 20px;
    }

    .mb-27 {
        margin-bottom: 27px;
    }

    .mb-29 {
        margin-bottom: 29px;
    }

    .mb-30 {
        margin-bottom: 30px;
    }

    .mb-33 {
        margin-bottom: 33px;
    }

    .mb-34 {
        margin-bottom: 34px;
    }

    .mb-40 {
        margin-bottom: 40px;
    }

    .mb-41 {
        margin-bottom: 41px;
    }

    .mb-42 {
        margin-bottom: 42px;
    }

    .mb-45 {
        margin-bottom: 45px;
    }

    .mb-47 {
        margin-bottom: 47px
    }

    .mb-52 {
        margin-bottom: 52px;
    }

    .mb-57 {
        margin-bottom: 57px;
    }

    .mb-60 {
        margin-bottom: 60px;
    }

    .mb-66 {
        margin-bottom: 66px;
    }

    .mb-70 {
        margin-bottom: 70px;
    }

    .mb-71 {
        margin-bottom: 71px;
    }

    .mb-95 {
        margin-bottom: 95px;
    }

    .mb-96 {
        margin-bottom: 96px;
    }

    .mb-100 {
        margin-bottom: 100px !important;
    }

    .mb-111 {
        margin-bottom: 111px;
    }

    .mt--83 {
        margin-top: -83px !important;
    }

    .mt-30 {
        margin-top: 30px;
    }

    .mt-41 {
        margin-top: 41px;
    }

    .mr-36 {
        margin-right: 36px;
    }

    .cursor-pointer {
        cursor: pointer;
    }
}
</style>